import segment from 'src/js/modules/analytics/segment';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackElementSettingsDialogCanceled = ({
  blockId,
  blockVariationId,
  settingsId,
  tabId,
  elementType,
}) => {
  if (!blockId) return;

  trackEvent(constants.events.ELEMENT_SETTINGS_DIALOG_CANCELED, {
    blockId,
    blockVariationId,
    settingsId,
    tabId,
    elementId: elementType,
  });
};

export default trackElementSettingsDialogCanceled;
